import { CreateBoatDTO, UpdateBoatDTO } from "../types/boat.types";
import { httpClient } from "./common";
import { withApiErrorHandling } from "../APIs/withApiErrorHandling";

export class BoatsAPI {
  private static readonly API_URL = "/boats";

  static async getBoatById(id: number) {
    return withApiErrorHandling(
      () => httpClient.get(`${this.API_URL}/${id}`, true),
      "Error al obtener la embarcación"
    );
  }

  static async postBoat(boat: CreateBoatDTO) {
    return withApiErrorHandling(
      () => httpClient.post(this.API_URL, boat, true),
      "Error al crear la embarcación"
    );
  }

  static async postBoatAdmin(boat: CreateBoatDTO, teamId: number) {
    return withApiErrorHandling(
      () => httpClient.post(`${this.API_URL}/admin`, boat, true),
      "Error al crear la embarcación"
    );
  }

  static async patchBoat(boat: UpdateBoatDTO) {
    const { id, ...boatWithoutId } = boat;
    return withApiErrorHandling(
      () => httpClient.patch(`${this.API_URL}/${id}`, boatWithoutId, true),
      "Error al actualizar la embarcación"
    );
  }

  static async getAllBoats(competitionId?: number) {
    const url = competitionId
      ? `${this.API_URL}?competition_id=${competitionId}`
      : this.API_URL;
    return withApiErrorHandling(
      () => httpClient.get(url, true),
      "Error al obtener la embarcación"
    );
  }
}
